import { useState } from "react";

import Button from "components/Button";
import ChunkUploadFile from "components/ChunkUploadFile";
import { NEW_CARRIER_CATEGORY } from "constants/base";
import { UPLOAD_DOCUMENT_URLS } from "constants/routes";
import UploadItem from "features/main/Loads/modules/UploadItem";
import useDeviceType from "hooks/useDeviceType";
import { UploadedFile } from "models/Component";
import { IPaymentProfile } from "models/HaulPay";
import styles from "./style.module.scss";

interface IProps {
  handleNext: VoidFunction;
  selectedPaymentProfile?: IPaymentProfile;
}

export default function UploadDocumentsForNOA({
  handleNext,
  selectedPaymentProfile
}: Readonly<IProps>) {
  const { isDesktop } = useDeviceType();
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  return (
    <form className={styles.uploadDocumentContainer}>
      <h3 className={styles.title}>Upload Documents</h3>

      <div className={styles.body}>
        <span>An existing profile matches the email address you’ve entered.</span>
        <div>
          <span>Any questions or concerns please email us at </span>
          <a href="mailto:invitedcarriers@haulpay.com" className="underline">
            invitedcarriers@haulpay.com
          </a>
        </div>
        <span>
          Upload an NOA or voided check to expedite the payment approval process for your carrier.
        </span>

        <ChunkUploadFile
          categories={NEW_CARRIER_CATEGORY}
          className="desktop:flex desktop:flex-col desktop:gap-4 desktop:text-lg"
          multiple
          urlCallback={
            UPLOAD_DOCUMENT_URLS({
              payment_profile_id: selectedPaymentProfile?.id
            }).NEW_CARRIER
          }
          onUploadFinished={(files: any) => {
            const newFiles: UploadedFile[] = files.map((file: any) => ({
              name: file.name,
              size: file.fileSize,
              type: file.fileType,
              fileType: file.categories.split(","),
              url: ""
            }));
            setUploadedFiles([...uploadedFiles, ...newFiles]);
          }}
        />
        {uploadedFiles.map((file) => (
          <div key={file.name} className="-mx-2">
            <UploadItem file={file} />
          </div>
        ))}
      </div>

      <Button
        rounded
        size="lg"
        onClick={handleNext}
        className="desktop:!rounded-base desktop:!w-48 mt-auto desktop:ml-auto desktop:flex-none">
        {isDesktop ? "Submit" : "SUBMIT"}
      </Button>
    </form>
  );
}
